/* eslint-disable camelcase */
import * as THREE from 'three'

export const drawIcon = (content, options) => {
  const {
    font,
    color,
    position,
    center_x,
    center_y,
    scale,
    scene,
    rotation,
    width,
    height,
    size: pSize
  } = options
  position[0] -= center_x * scale
  position[1] += center_y * scale

  const geometry = new THREE.PlaneGeometry(width * scale, height * scale)
  const material = new THREE.MeshBasicMaterial({ color })
  const rect = new THREE.Mesh(geometry, material)
  rect.position.set(position.x, position.y, position.z)

  const labelGeometry = new THREE.TextGeometry(content, {
    font: font,
    size: pSize || 16 * scale,
    height: 0
  })

  labelGeometry.center()
  const labelMaterial = new THREE.MeshBasicMaterial({ color })
  const label = new THREE.Mesh(labelGeometry, labelMaterial)
  label.position.set(...position)
  label.renderOrder = 1

  const triangle = new THREE.Group()
  triangle.add(rect)
  triangle.obj = rect
  triangle.add(label)
  triangle.obj = label

  if (rotation) {
    triangle.rotateOnAxis(
      new THREE.Vector3(0, 0, 1),
      (rotation * Math.PI) / 180
    )
  }

  scene.add(triangle)
  return triangle
}
